/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, app: NonNullable<unknown> }} Directory_Submit_Enrich_Share_TextInputs */

const en_directory_submit_enrich_share_text = /** @type {(inputs: Directory_Submit_Enrich_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I just listed ${i?.name} on ${i?.app} 🚀`)
};

const zh_directory_submit_enrich_share_text = /** @type {(inputs: Directory_Submit_Enrich_Share_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我刚在 ${i?.app} 收录了 ${i?.name} 🚀`)
};

/**
* | output |
* | --- |
* | "I just listed {name} on {app} 🚀" |
*
* @param {Directory_Submit_Enrich_Share_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_share_text = /** @type {((inputs: Directory_Submit_Enrich_Share_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Share_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_share_text(inputs)
	return zh_directory_submit_enrich_share_text(inputs)
});
export { directory_submit_enrich_share_text as "directory.submit.enrich.share_text" }